// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host::ng-deep .dashboard_grid_item {
  margin-left: 0.5rem;
  height: calc(100% - 9rem);
}
:host::ng-deep .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row {
  width: calc(100% - 1rem);
  height: 2.86rem;
}
:host::ng-deep .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row .cell_row {
  padding: 5px 0;
}
:host::ng-deep .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row .cell_row .cell_header {
  background-color: #eceef3;
  font-weight: bolder;
  padding: 0;
}
:host::ng-deep .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row #header_title_row {
  padding: 0.5rem 0 0.5rem 0.5rem;
  background-color: #eceef3;
  border-bottom: 1px solid #050505;
}
:host::ng-deep .dashboard_grid_item .dashboard_grid_content {
  overflow: auto;
  height: 100%;
}
:host::ng-deep .cell_row {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 5% 22% 15% 33% 15% 10%;
}
:host::ng-deep .cell_row .user_data {
  max-height: 130px;
  overflow: auto;
}

#sim_group,
.sim_group {
  width: calc(100% - 30px);
  padding: 15px;
}
#sim_group .sim_row_container,
.sim_group .sim_row_container {
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
#sim_group .sim_row_container:last-of-type,
.sim_group .sim_row_container:last-of-type {
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
#sim_group .sim_scenario,
#sim_group .sim_mnemonic,
#sim_group .sim_description,
.sim_group .sim_scenario,
.sim_group .sim_mnemonic,
.sim_group .sim_description {
  float: left;
  min-height: 30px;
  /* padding: 5px; */
  box-sizing: border-box;
}
#sim_group .sim_scenario:hover .inner_cell_text .inline-edit,
#sim_group .sim_mnemonic:hover .inner_cell_text .inline-edit,
#sim_group .sim_description:hover .inner_cell_text .inline-edit,
.sim_group .sim_scenario:hover .inner_cell_text .inline-edit,
.sim_group .sim_mnemonic:hover .inner_cell_text .inline-edit,
.sim_group .sim_description:hover .inner_cell_text .inline-edit {
  text-decoration: underline;
}
#sim_group .sim_scenario .inner_cell_text,
#sim_group .sim_mnemonic .inner_cell_text,
#sim_group .sim_description .inner_cell_text,
.sim_group .sim_scenario .inner_cell_text,
.sim_group .sim_mnemonic .inner_cell_text,
.sim_group .sim_description .inner_cell_text {
  line-height: 20px;
  padding: 0px 0px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
#sim_group .sim_scenario .inner_cell_text .inline-edit,
#sim_group .sim_mnemonic .inner_cell_text .inline-edit,
#sim_group .sim_description .inner_cell_text .inline-edit,
.sim_group .sim_scenario .inner_cell_text .inline-edit,
.sim_group .sim_mnemonic .inner_cell_text .inline-edit,
.sim_group .sim_description .inner_cell_text .inline-edit {
  line-height: 20px;
  padding: 5px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
#sim_group .sim_scenario .inner_cell_text .inline-edit.force_multiline_text,
#sim_group .sim_mnemonic .inner_cell_text .inline-edit.force_multiline_text,
#sim_group .sim_description .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_scenario .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_mnemonic .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_description .inner_cell_text .inline-edit.force_multiline_text {
  white-space: normal !important;
}
#sim_group .sim_scenario .inner_cell_text input,
#sim_group .sim_mnemonic .inner_cell_text input,
#sim_group .sim_description .inner_cell_text input,
.sim_group .sim_scenario .inner_cell_text input,
.sim_group .sim_mnemonic .inner_cell_text input,
.sim_group .sim_description .inner_cell_text input {
  line-height: 20px;
  margin: 0;
  padding: 4px 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}
#sim_group .sim_row_toggle,
#sim_group .sim_last_updated,
#sim_group .sim_dataset,
#sim_group .sim_delete,
#sim_group .sim_notifications,
#sim_group .sim_action,
.sim_group .sim_row_toggle,
.sim_group .sim_last_updated,
.sim_group .sim_dataset,
.sim_group .sim_delete,
.sim_group .sim_notifications,
.sim_group .sim_action {
  float: left;
  min-height: 30px;
  padding: 5px 5px;
  box-sizing: border-box;
}
#sim_group .inner_cell_text,
.sim_group .inner_cell_text {
  line-height: 20px;
  padding: 5px 0px;
  display: block;
  box-sizing: border-box;
  vertical-align: top;
}
#sim_group .inner_cell_text a,
.sim_group .inner_cell_text a {
  color: #2b495e;
}
#sim_group .inner_cell_text a:hover, #sim_group .inner_cell_text a:focus,
.sim_group .inner_cell_text a:hover,
.sim_group .inner_cell_text a:focus {
  color: #28a745;
}
#sim_group .sim_scenario,
.sim_group .sim_scenario {
  width: 22%;
}
#sim_group .sim_mnemonic,
.sim_group .sim_mnemonic {
  width: 15%;
}
#sim_group .sim_description,
.sim_group .sim_description {
  width: 33%;
}
#sim_group .result_header,
.sim_group .result_header {
  width: 100%;
}
#sim_group .manage_resultsets_table .sim_description,
.sim_group .manage_resultsets_table .sim_description {
  width: 33%;
}
#sim_group .sim_last_updated,
.sim_group .sim_last_updated {
  width: 15%;
}
#sim_group .sim_dataset,
.sim_group .sim_dataset {
  width: 160px;
}
#sim_group .sim_delete,
.sim_group .sim_delete {
  width: 40px;
}
#sim_group .sim_notifications,
.sim_group .sim_notifications {
  width: 40px;
}
#sim_group .sim_action,
.sim_group .sim_action {
  width: 10%;
}
#sim_group .sim_notifications .icon_notification,
.sim_group .sim_notifications .icon_notification {
  color: #ffc107;
}
#sim_group .sim_delete button,
.sim_group .sim_delete button {
  opacity: 0.1;
}
#sim_group .sim_description .inner_cell_text.wrap_text,
.sim_group .sim_description .inner_cell_text.wrap_text {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 30px);
}
#sim_group .sim_description .more_link,
#sim_group .sim_description .less_link,
.sim_group .sim_description .more_link,
.sim_group .sim_description .less_link {
  line-height: 20px;
  padding: 5px 0px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
#sim_group .sim_description .more_link a,
#sim_group .sim_description .less_link a,
.sim_group .sim_description .more_link a,
.sim_group .sim_description .less_link a {
  color: #2b495e;
}
#sim_group .sim_description .more_link a:hover, #sim_group .sim_description .more_link a:focus,
#sim_group .sim_description .less_link a:hover,
#sim_group .sim_description .less_link a:focus,
.sim_group .sim_description .more_link a:hover,
.sim_group .sim_description .more_link a:focus,
.sim_group .sim_description .less_link a:hover,
.sim_group .sim_description .less_link a:focus {
  text-decoration: underline;
}
#sim_group .sim_row_toggle,
.sim_group .sim_row_toggle {
  width: 5%;
  padding-left: 5px;
}

.action_button_group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action_button_group swal {
  display: none !important;
  position: absolute !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/results/dialog/manage-results/manage-results.component.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;EACA,yBAAA;AADJ;AAKM;EACE,wBAAA;EACA,eAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AAKU;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;AAHZ;AAOQ;EACE,+BAAA;EACA,yBAAA;EACA,gCAAA;AALV;AAWI;EACE,cAAA;EACA,YAAA;AATN;AAaE;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;AAXJ;AAaI;EACE,iBAAA;EACA,cAAA;AAXN;;AAiBA;;EAEE,wBAAA;EACA,aAAA;AAdF;AAgBE;;EACE,eAAA;EACA,6BAAA;AAbJ;AAeI;;EACE,eAAA;EACA,6BAAA;AAZN;AAgBE;;;;;;EAGE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAXJ;AAgBQ;;;;;;EACE,0BAAA;AATV;AAcI;;;;;;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AAPN;AASM;;;;;;EACE,iBAAA;EACA,YAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AAFR;AAIQ;;;;;;EACE,8BAAA;AAGV;AACM;;;;;;EACE,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AAMR;AADE;;;;;;;;;;;;EAME,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AASJ;AANE;;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AASJ;AAPI;;EACE,cAAA;AAUN;AARM;;;EAEE,cAAA;AAWR;AANE;;EACE,UAAA;AASJ;AAPE;;EACE,UAAA;AAUJ;AARE;;EACE,UAAA;AAWJ;AARE;;EACE,WAAA;AAWJ;AAPI;;EACE,UAAA;AAUN;AANE;;EACE,UAAA;AASJ;AAPE;;EACE,YAAA;AAUJ;AARE;;EACE,WAAA;AAWJ;AATE;;EACE,WAAA;AAYJ;AAVE;;EACE,UAAA;AAaJ;AATI;;EACE,cAAA;AAYN;AAPI;;EACE,YAAA;AAUN;AAJM;;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAOR;AAHI;;;;EAEE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAON;AALM;;;;EACE,cAAA;AAUR;AARQ;;;;;;;EAEE,0BAAA;AAeV;AATE;;EACE,SAAA;EACA,iBAAA;AAYJ;;AARA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAWF;;AARA;EACE,wBAAA;EACA,6BAAA;AAWF","sourcesContent":["// Import the dashboard grid styles to match scenario-table\r\n:host::ng-deep {\r\n  .dashboard_grid_item {\r\n    margin-left: 0.5rem;\r\n    height: calc(100% - 9rem);\r\n\r\n    // table head\r\n    .dashboard_grid_header.header-sticky {\r\n      .header_row {\r\n        width: calc(100% - 1rem);\r\n        height: 2.86rem;\r\n\r\n        .cell_row {\r\n          padding: 5px 0;\r\n\r\n          .cell_header {\r\n            background-color: #eceef3;\r\n            font-weight: bolder;\r\n            padding: 0;\r\n          }\r\n        }\r\n\r\n        #header_title_row {\r\n          padding: 0.5rem 0 0.5rem 0.5rem;\r\n          background-color: #eceef3;\r\n          border-bottom: 1px solid #050505;\r\n        }\r\n      }\r\n    }\r\n\r\n    // table body\r\n    .dashboard_grid_content {\r\n      overflow: auto;\r\n      height: 100%;\r\n    }\r\n  }\r\n\r\n  .cell_row {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    grid-template-columns: 5% 22% 15% 33% 15% 10%;\r\n\r\n    .user_data {\r\n      max-height: 130px;\r\n      overflow: auto;\r\n    }\r\n  }\r\n}\r\n\r\n// Keep existing sim_group styles for the content rows\r\n#sim_group,\r\n.sim_group {\r\n  width: calc(100% - 30px);\r\n  padding: 15px;\r\n\r\n  .sim_row_container {\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid #ccc;\r\n\r\n    &:last-of-type {\r\n      padding: 10px 0;\r\n      border-bottom: 1px solid #ccc;\r\n    }\r\n  }\r\n\r\n  .sim_scenario,\r\n  .sim_mnemonic,\r\n  .sim_description {\r\n    float: left;\r\n    min-height: 30px;\r\n    /* padding: 5px; */\r\n    box-sizing: border-box;\r\n    // Remove padding so columns align with header\r\n\r\n    &:hover {\r\n      .inner_cell_text {\r\n        .inline-edit {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n\r\n    .inner_cell_text {\r\n      line-height: 20px;\r\n      padding: 0px 0px;\r\n      overflow: hidden !important;\r\n      text-overflow: ellipsis !important;\r\n      white-space: nowrap !important;\r\n\r\n      .inline-edit {\r\n        line-height: 20px;\r\n        padding: 5px;\r\n        overflow: hidden !important;\r\n        text-overflow: ellipsis !important;\r\n        white-space: nowrap !important;\r\n\r\n        &.force_multiline_text {\r\n          white-space: normal !important;\r\n        }\r\n      }\r\n\r\n      input {\r\n        line-height: 20px;\r\n        margin: 0;\r\n        padding: 4px 5px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 4px;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n      }\r\n    }\r\n  }\r\n\r\n  .sim_row_toggle,\r\n  .sim_last_updated,\r\n  .sim_dataset,\r\n  .sim_delete,\r\n  .sim_notifications,\r\n  .sim_action {\r\n    float: left;\r\n    min-height: 30px;\r\n    padding: 5px 5px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .inner_cell_text {\r\n    line-height: 20px;\r\n    padding: 5px 0px;\r\n    display: block;\r\n    box-sizing: border-box;\r\n    vertical-align: top;\r\n\r\n    a {\r\n      color: #2b495e;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: #28a745;\r\n      }\r\n    }\r\n  }\r\n\r\n  .sim_scenario {\r\n    width: 22%;\r\n  }\r\n  .sim_mnemonic {\r\n    width: 15%;\r\n  }\r\n  .sim_description {\r\n    width: 33%;\r\n  }\r\n\r\n  .result_header {\r\n    width: calc(100%);\r\n  }\r\n\r\n  .manage_resultsets_table {\r\n    .sim_description {\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .sim_last_updated {\r\n    width: 15%;\r\n  }\r\n  .sim_dataset {\r\n    width: 160px;\r\n  }\r\n  .sim_delete {\r\n    width: 40px;\r\n  }\r\n  .sim_notifications {\r\n    width: 40px;\r\n  }\r\n  .sim_action {\r\n    width: 10%;\r\n  }\r\n\r\n  .sim_notifications {\r\n    .icon_notification {\r\n      color: #ffc107;\r\n    }\r\n  }\r\n\r\n  .sim_delete {\r\n    button {\r\n      opacity: 0.1;\r\n    }\r\n  }\r\n\r\n  .sim_description {\r\n    .inner_cell_text {\r\n      &.wrap_text {\r\n        display: inline-block;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        width: calc(100% - 30px);\r\n      }\r\n    }\r\n\r\n    .more_link,\r\n    .less_link {\r\n      line-height: 20px;\r\n      padding: 5px 0px;\r\n      display: inline-block;\r\n      box-sizing: border-box;\r\n      vertical-align: top;\r\n\r\n      a {\r\n        color: #2b495e;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .sim_row_toggle {\r\n    width: 5%;\r\n    padding-left: 5px;\r\n  }\r\n}\r\n\r\n.action_button_group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.action_button_group swal {\r\n  display: none !important;\r\n  position: absolute !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
